import { render, staticRenderFns } from "./RecommendationResult.vue?vue&type=template&id=91a847ee"
import script from "./RecommendationResult.vue?vue&type=script&lang=js"
export * from "./RecommendationResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports